import React, { Fragment, useState } from "react"
import classnames from "classnames"
import _get from "lodash/get"
import _size from "lodash/size"
import _filter from "lodash/filter"
import _toUpper from "lodash/toUpper"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import DefaultContainer from "shared/components/DefaultContainer"
import DefaultTitle from "shared/components/DefaultTitle"
import Typograph from "components/Typograph"
import ModernFloatLabelSelect from "shared/components/ModernFloatLabelSelect"
import EmailModal from "components/ModernEmailModal"
import EmptyState from "shared/components/EmptyState"
import DetailList from "./components/DetailsList"
import WrapperSkeleton from "components/WrapperSkeleton"
import DateRange from "components/DateRangePicker"

import { useTrafficDetails } from "./utils/useTrafficDetails"
import { sendTrafficEmail, downloadDetails } from "services/state/actions"
import { formatDate } from "services/utils/date"
import { useResponseAction } from "./utils/useResponseAction"
import { useOptionsByTrafficSummary } from "./utils/useOptionsByTrafficSummary"

import styles from "./styles.css"
import iconError from "../../assets/svg/erro-desbloqueio.svg"

const DataTrafficDetails = ({
  t,
  emailCustomer,
  match,
  useTrafficDetails,
  trafficDetails,
  sendTrafficEmail,
  customer,
  trafficMail,
  downloadTraffic,
  downloadDetails,
  trafficLoading,
  useOptionsByTrafficSummary
}) => {
  const params = _get(match, "params", { id: null })
  const { id } = params
  const [modalEmail, setModalEmail] = useState(false)
  const [dates, changeRangeDatesForDetailing, submitTrafficDetails] =
    useTrafficDetails(id)
  useResponseAction(trafficMail, downloadTraffic)
  const [options, currentOption, setCurrentOption] =
    useOptionsByTrafficSummary(id)

  const { startDate, endDate } = dates
  const { data, errors, loading } = trafficDetails
  const trafficDataDetailsList = _filter(
    _get(data, "trafficDataDetailsList", []),
    (trafficDetail) => {
      return _toUpper(trafficDetail.local) === _toUpper(currentOption.value)
    }
  )
  const isChildrenReady =
    !loading &&
    !trafficMail.loading &&
    !downloadTraffic.loading &&
    !trafficLoading

  const hasErrorInRequests = !id || !_size(data) || errors

  const submitEmail = (email) => {
    const { startDate, endDate } = dates

    sendTrafficEmail(
      {
        serviceId: id
      },
      {
        customerName: customer.name,
        customerSegment: customer.customerSegment,
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        customerEmail: email
      }
    )
  }

  const downloadDetail = () => {
    const { startDate, endDate } = dates

    downloadDetails({
      serviceId: id,
      customerName: customer.name,
      customerSegment: customer.customerSegment,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    })
  }

  if (hasErrorInRequests && !loading) {
    return <EmptyState icon={iconError} description={t("ERROR_REQUEST")} />
  }

  return (
    <Fragment>
      <section className={classnames("Grid", "fullHeight")}>
        <div className={containerTitle}>
          <DefaultTitle className={styles.defaultTitleClass}>
            {t("DATA_QUOTA")}
          </DefaultTitle>
          <DateRange
            startDate={startDate}
            endDate={endDate}
            onConfirm={submitTrafficDetails}
            onDatesChange={changeRangeDatesForDetailing}
            isOutsideRange={false}
            anchorDirection="right"
          />
        </div>

        <DefaultContainer customClass={styles.customClassesContainer}>
          <Typograph preset="h2" htmlTag="h2">
            {t("MSG_0044")}
          </Typograph>
          <div className={containerButtonClasses}>
            <ModernFloatLabelSelect
              id="reason"
              options={options}
              value={currentOption}
              placeholder="Filtar por produtos"
              onChange={setCurrentOption}
              customStyles={customFloatLabelSelect}
              className={styles.selectCustomClasses}
              isDisabled={loading}
            />
            <Typograph
              htmlTag="button"
              preset="link"
              size="small"
              weight="medium"
              onClick={() => {
                setModalEmail(true)
              }}
              classNames={styles.linkContainer}
              disabled={loading}
            >
              {t("MSG_0045")}
            </Typograph>
            <Typograph
              htmlTag="button"
              preset="link"
              size="small"
              weight="medium"
              onClick={downloadDetail}
              disabled={loading}
            >
              {t("MSG_0148")}
            </Typograph>
          </div>
          <WrapperSkeleton
            path="detailTraffic"
            isChildrenReady={isChildrenReady}
          >
            <DetailList t={t} trafficDataDetailsList={trafficDataDetailsList} />
          </WrapperSkeleton>
        </DefaultContainer>
      </section>
      <EmailModal
        isOpen={modalEmail}
        email={emailCustomer}
        onClose={() => {
          setModalEmail(false)
        }}
        onSubmit={(email) => {
          submitEmail(email)
          setModalEmail(false)
        }}
        confirmButtonTex="Enviar"
      />
    </Fragment>
  )
}

const containerTitle = classnames(
  "u-flex u-flexJustifyBetween u-flexAlignItemsCenter",
  styles.titleClasses
)

const containerButtonClasses = classnames(
  "u-flex u-flexAlignCenter",
  styles.containerClasses
)

const customFloatLabelSelect = {
  control: (provided) => ({
    ...provided,
    padding: "13px 12px!important",
    fontSize: "14px!important",
    fontWeight: "600!important",
    color: "#767474!important",
    margin: "0px !important"
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0!important"
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#767474!important",
    margin: "0!important"
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#3C4646!important"
  })
}

const mapStateToProps = ({
  customer,
  trafficDetails,
  trafficMail,
  downloadTraffic,
  traffic
}) => ({
  emailCustomer: customer.data.email,
  trafficDetails,
  customer: customer.data,
  trafficMail,
  downloadTraffic,
  trafficLoading: traffic.loading
})

DataTrafficDetails.propTypes = {
  t: PropTypes.func,
  emailCustomer: PropTypes.string,
  match: PropTypes.object,
  useTrafficDetails: PropTypes.func,
  trafficDetails: PropTypes.shape({
    data: PropTypes.array,
    errors: PropTypes.object,
    loading: PropTypes.bool
  }),
  customer: PropTypes.object,
  sendTrafficEmail: PropTypes.func,
  trafficMail: PropTypes.object,
  downloadDetails: PropTypes.func,
  downloadTraffic: PropTypes.object,
  trafficLoading: PropTypes.bool,
  useOptionsByTrafficSummary: PropTypes.func
}

const enhace = compose(
  translate(),
  connect(mapStateToProps, {
    useTrafficDetails,
    sendTrafficEmail,
    downloadDetails,
    useOptionsByTrafficSummary
  })
)

export default enhace(DataTrafficDetails)



// WEBPACK FOOTER //
// ./src/scenes/DataTraffic/DataTrafficDetails.js